
import VDatePicker from '~/components/ui/VDatePicker'
import Container from '~/components/layout/Container'
import EventItem from '~/components/event/EventItem'
import VFormGroup from '~/components/ui/VFormGroup'
import VCheckbox from '~/components/ui/VCheckbox'
import VButton from '~/components/ui/VButton'
import VRadio from '~/components/ui/VRadio'
import { EVENTS, FILTER_GROUP } from '~/constants/api'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
    async asyncData({ $axios, params, store, app }) {
        const res = await $axios.get(EVENTS)
        const filter = await $axios.get(FILTER_GROUP + '/kevents')
        return { 
            events: res.data.items,
            filterData: filter.data.items,
            filterLists: {
                locations: [{
                    // TODO: translate
                    title: app.i18n.t('general.all'),
                    value: ''
                }, ...filter.data.items.find(el => el.fieldName === 'placeId').enums],
                prices: filter.data.items.find(el => el.fieldName === 'price').enums,
                themes: [{
                    // TODO: translate
                    title: app.i18n.t('general.all'),
                    value: ''
                }, ...filter.data.items.find(el => el.fieldName === 'theme').enums]
            },
        }
    },
    data() {
        return {
            filters: {
                theme: '',
                placeId: '',
                search: '',
                price: '',
                eventDate: '',
            },
            filterLists: {
                locations: [],
                themes: [],
                prices: [],
            },
            filterData: null,
            events: [],
        }
    },
    computed: {
        ...mapState('profile', [
            'currentAccount'
        ])
    },
    methods: {
        changePaid(value) {
            this.filters.price = value
            this.getItems()
        },
        changeDate(value) {
            this.filters.eventDate = value
            this.getItems()
        },
        resetFilters() {
            this.filters.theme =  ''
            this.filters.placeId =  ''
            this.filters.search =  ''
            this.filters.price =  ''
            this.filters.eventDate =  ''
            this.getItems()
        },
        getItems() {
            this.$axios.get(EVENTS, {
                params: this.prepareQueryParams(this.filters, this.filterData)
            }).then(res => {
                this.events = res.data.items
            })
        },
    },
    components: {
        VDatePicker,
        VFormGroup,
        Container,
        VCheckbox,
        EventItem,
        VButton,
        VRadio
    }
}
